import useWebSocket from 'react-use-websocket'

const webSocketUrl = process.env.REACT_APP_CHAT_SERVER as string

export function useSubscription() {
  return useWebSocket(webSocketUrl)
}
